import Vapi from "vuex-rest-api";
import { lazyAxFactory } from "@/utils";

const api = new Vapi({
  axios: lazyAxFactory(),
  state: {
    identity: null
  }
})
  .post({
    action: "getIdentity",
    property: "identity",
    queryParams: true,
    path: "/auth"
  })
  .getStore();

export default {
  namespaced: true,
  state: api.state,
  getters: {
    identity: state => state.identity
  },
  mutations: { ...api.mutations },
  actions: { ...api.actions }
};
